module.exports = __webpack_public_path__ + "static/MessyDoodle-4de80d41e5db03e11863e4217fe628b4.png";